window.ManageEEOFormsForm = function (scope, eeoDataService, $q, $state) {

    var self = this;
    var formName = "manage-eeo-forms-form";
    var _protected = BaseForm.call(self, formName, scope);

    self.load = function (brandId) {

        self.loading = true;
        self.saving = false;
        self.eeoForms = [];
        self.hasOwnedForm = true;
        self.brandId = brandId;

        loadEEOForms();
    };

    var loadEEOForms = function () {

        self.saving = true;

        eeoDataService
            .getBrandEEOForms(self.brandId)
            .then(function (forms) {

                self.eeoForms = forms || [];
                self.hasOwnedForm = _.findWhere(self.eeoForms, {is_owner: true});
                self.loading = false;
                self.saving = false;

            }, function (err) {
                console.error(err);
            });
    };

    self.save = function () {};

    self.toggleFormActivation = function (form) {

        self.saving = true;
        var toggleActivation;
        var notification;

        if (form.is_active) {
            toggleActivation = eeoDataService.activateBrandEEOForm(self.brandId, form.id);
            notification = $filter("translate")("Form activated successfully!");
        }
        else {
            toggleActivation = eeoDataService.deactivateBrandEEOForm(self.brandId, form.id);
            notification = $filter("translate")("Form deactivated successfully!");
        }

        toggleActivation
            .then(function () {

                var parentForm = _.findWhere(self.eeoForms, {is_owner: false});
                if (parentForm) {
                    parentForm.is_active = !form.is_active;
                }

                self.saving = false;
                HNotifications.show({
                    title: $filter("translate")("Success"),
                    desc: notification,
                    icon: "fa-check-circle",
                    type: "success"
                });

                loadEEOForms();

            }, function (err) {
                self.saving = false;
                HNotifications.show({
                    title: $filter("translate")("Error"),
                    desc: $filter("translate")("Something went wrong!"),
                    icon: "fa-times-circle",
                    type: "danger"
                });
            });
    };
};